module.exports = __webpack_public_path__ + "fa-regular-400.f0f8230116992e521526.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-regular-400.woff2
// module id = ../../../../../src/assets/fonts/webfonts/fa-regular-400.woff2
// module chunks = styles